export const exploreAppsTranslations = {
  en: {
    heading: 'Explore More Bonobo Apps',
    apps: {
      actions: 'Elegant todo list that integrates with Timepage',
      timepage: 'Beautiful calendar with weather and smart features',
      flow: 'Infinite notebook for sketching and note-taking',
      overlap: 'Free time zone coordination tool',
      bundle: 'Get all apps at 44% savings'
    }
  },
  'en-gb': {
    heading: 'Explore More Bonobo Apps',
    apps: {
      actions: 'Elegant todo list that integrates with Timepage',
      timepage: 'Beautiful calendar with weather and smart features',
      flow: 'Infinite notebook for sketching and note-taking',
      overlap: 'Free time zone coordination tool',
      bundle: 'Get all apps at 44% savings'
    }
  },
  de: {
    heading: 'Entdecken Sie weitere Bonobo-Apps',
    apps: {
      actions: 'Elegante Aufgabenliste, die sich in Timepage integriert',
      timepage: 'Schöner Kalender mit Wetter und intelligenten Funktionen',
      flow: 'Unendliches Notizbuch zum Skizzieren und Notieren',
      overlap: 'Kostenloses Tool zur Zeitzonenkoordination',
      bundle: 'Holen Sie sich alle Apps mit 44 % Rabatt'
    }
  },
  es: {
    heading: 'Explora más aplicaciones de Bonobo',
    apps: {
      actions: 'Lista de tareas elegante que se integra con Timepage',
      timepage: 'Calendario hermoso con clima y funciones inteligentes',
      flow: 'Cuaderno infinito para dibujar y tomar notas',
      overlap: 'Herramienta gratuita de coordinación de zonas horarias',
      bundle: 'Obtén todas las aplicaciones con un 44% de descuento'
    }
  },
  fr: {
    heading: "Découvrez plus d'applications Bonobo",
    apps: {
      actions: "Liste de tâches élégante qui s'intègre avec Timepage",
      timepage: 'Beau calendrier avec météo et fonctionnalités intelligentes',
      flow: 'Carnet infini pour dessiner et prendre des notes',
      overlap: 'Outil gratuit de coordination des fuseaux horaires',
      bundle: 'Obtenez toutes les applications avec 44% de réduction'
    }
  },
  it: {
    heading: 'Esplora altre app Bonobo',
    apps: {
      actions: 'Lista di attività elegante che si integra con Timepage',
      timepage: 'Bellissimo calendario con meteo e funzioni intelligenti',
      flow: 'Taccuino infinito per schizzi e appunti',
      overlap: 'Strumento gratuito di coordinamento dei fusi orari',
      bundle: 'Ottieni tutte le app con il 44% di sconto'
    }
  },
  ja: {
    heading: '他のBonoboアプリを見る',
    apps: {
      actions: 'Timepageと統合されたエレガントなToDoリスト',
      timepage: '天気とスマート機能を備えた美しいカレンダー',
      flow: 'スケッチとメモ取りのための無限のノートブック',
      overlap: '無料のタイムゾーン調整ツール',
      bundle: 'すべてのアプリを44%オフで入手'
    }
  },
  ko: {
    heading: '더 많은 Bonobo 앱 살펴보기',
    apps: {
      actions: 'Timepage와 통합되는 우아한 할 일 목록',
      timepage: '날씨와 스마트 기능이 있는 아름다운 캘린더',
      flow: '스케치와 메모를 위한 무한 노트북',
      overlap: '무료 시간대 조정 도구',
      bundle: '모든 앱을 44% 할인된 가격으로 구매'
    }
  },
  'pt-br': {
    heading: 'Explore mais aplicativos Bonobo',
    apps: {
      actions: 'Lista de tarefas elegante que se integra com Timepage',
      timepage: 'Belo calendário com clima e recursos inteligentes',
      flow: 'Caderno infinito para esboços e anotações',
      overlap: 'Ferramenta gratuita de coordenação de fuso horário',
      bundle: 'Obtenha todos os aplicativos com 44% de desconto'
    }
  },
  ru: {
    heading: 'Изучите другие приложения Bonobo',
    apps: {
      actions: 'Элегантный список задач, который интегрируется с Timepage',
      timepage: 'Красивый календарь с погодой и умными функциями',
      flow: 'Бесконечная записная книжка для набросков и заметок',
      overlap: 'Бесплатный инструмент координации часовых поясов',
      bundle: 'Получите все приложения со скидкой 44%'
    }
  },
  tr: {
    heading: 'Daha Fazla Bonobo Uygulamasını Keşfedin',
    apps: {
      actions: 'Timepage ile entegre olan zarif yapılacaklar listesi',
      timepage: 'Hava durumu ve akıllı özellikler içeren güzel takvim',
      flow: 'Çizim ve not alma için sonsuz not defteri',
      overlap: 'Ücretsiz saat dilimi koordinasyon aracı',
      bundle: 'Tüm uygulamaları %44 indirimle alın'
    }
  },
  'zh-hans': {
    heading: '探索更多 Bonobo 应用',
    apps: {
      actions: '与 Timepage 集成的优雅待办事项列表',
      timepage: '带有天气和智能功能的精美日历',
      flow: '用于素描和笔记的无限笔记本',
      overlap: '免费时区协调工具',
      bundle: '以 44% 折扣获取所有应用'
    }
  },
  'zh-hant': {
    heading: '探索更多 Bonobo 應用',
    apps: {
      actions: '與 Timepage 整合的優雅待辦事項清單',
      timepage: '帶有天氣和智慧功能的精美日曆',
      flow: '用於素描和筆記的無限筆記本',
      overlap: '免費時區協調工具',
      bundle: '以 44% 折扣獲取所有應用'
    }
  }
}

export const getExploreAppsText = (lang = 'en') => {
  return exploreAppsTranslations[lang] || exploreAppsTranslations.en
}
